module.exports = __webpack_public_path__ + "static/4-5d2c825b3dd28e1f918ce06911b4aa5d.jpg";